import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetSuppliers = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/suppliers`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load suppliers.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateSupplier = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/suppliers/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create supplier.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateSupplier = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/suppliers/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update supplier.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteSupplier = async (id: number): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/suppliers/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete supplier.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
